import { useEffect, useContext } from 'react';
import { useRealtime } from './RealtimeProvider';
import { ConfigContext } from '../contexts/ConfigContext';
import { CHANGEDDATAUSER, UPDATEDATAINI, UPDATEDATAINSUPORTE } from '../store/actions';
import Swal from 'sweetalert2';

const TARGETS = {
  UPDATE_DATA_INI: new Set(['config:updateDataIni', 'config.updateDataIni', 'UPDATEDATAINI', 'config:UPDATEDATAINI']),
};

export default function RealtimeControlBridge() {
  const {on} = useRealtime();
  const config = useContext(ConfigContext);

  useEffect(() => {
    if (!on || !config?.dispatch) return;

    const handleControl = (event) => {
      if (!event || typeof event !== 'object') return;

      const {action = '', target = '', payload: rawPayload, meta: rawMeta} = event;

      const payload = rawPayload && typeof rawPayload === 'object' ? rawPayload : {};
      const meta = rawMeta && typeof rawMeta === 'object' ? rawMeta : {};

      const actionKey = (action || meta.action || '').toLowerCase();
      const targetKey = target || meta.target || '';

      const matchTarget = (allowedSet) => targetKey && allowedSet.has(targetKey);
      
      switch (actionKey) {
        case 'reload':
          window.location.reload();
          break;

        case 'dataini':
          config.dispatch({type: UPDATEDATAINI, updateDataIni: false});
          config.dispatch({type: UPDATEDATAINI, updateDataIni: true});
          break;

        case 'datauser':
          config.dispatch({type: CHANGEDDATAUSER, changedDataUser: false});
          config.dispatch({type: CHANGEDDATAUSER, changedDataUser: true});
          config.dispatch({type: UPDATEDATAINI, updateDataIni: false});
          config.dispatch({type: UPDATEDATAINI, updateDataIni: true});
          break;

        case 'lead':
        case 'leadsuporte':
          
          config.dispatch({type: UPDATEDATAINSUPORTE, updateDataIniSuporte: false});
          config.dispatch({type: UPDATEDATAINSUPORTE, updateDataIniSuporte: true});
          break;

        case 'logout':
          Swal.fire({
            icon: 'warning',
            title: 'Sessão Encerrada!',
            html: 'Sua sessão foi encerrada remotamente!',
            timer: 3000,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            backdrop: true,
            didOpen: () => {
              Swal.showLoading();
            }
          }).then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/auth/login';
          });
          break;

        case 'refresh':
        case 'dispatch': {
          if (!matchTarget(TARGETS.UPDATE_DATA_INI)) break;
          const valueFromPayload = typeof payload.updateDataIni === 'boolean' ? payload.updateDataIni : typeof payload.value === 'boolean' ? payload.value : true;
          config.dispatch({type: UPDATEDATAINI, updateDataIni: valueFromPayload});
          break;
        }

        default:
          break;
      }
    };

    const off = on('control', handleControl);
    return () => off?.();
  }, [on, config]);

  return null;
}
